import type { DryRunInput } from '../api/bulk-migrations';

/**
 * What the Analyze panel sends, as plain data.
 *
 * Sandboxes are IN by default. The migration is meant for every client,
 * sandboxes included, and some environments (dev) have nothing else, so
 * excluding them by default turned a whole analysis into "skipped: sandbox
 * excluded".
 *
 * Leaving them out is an opt-in, and it only applies to "All clients". When
 * the operator picks clients by hand, that list is the decision: a sandbox they
 * picked is analysed, never silently skipped by a toggle they may not have
 * looked at.
 */

export const EXCLUDE_SANDBOXES_BY_DEFAULT = false;

export type AnalyzeScope = 'all' | 'chosen';

export function analyzeRequest(input: {
    readonly scope: AnalyzeScope;
    readonly selected: readonly string[];
    readonly excludeSandboxes: boolean;
    readonly reason: string;
}): DryRunInput {
    const reason = input.reason.trim();
    return {
        excludeSandboxes: input.scope === 'all' && input.excludeSandboxes,
        ...(input.scope === 'chosen' ? { tenantIds: input.selected } : {}),
        ...(reason ? { reason } : {}),
    };
}

/** The toggle only means something for "All clients". */
export function showsSandboxToggle(scope: AnalyzeScope): boolean {
    return scope === 'all';
}
